<template>
    <!--
        Square logo tile (vs. circular Avatar) — designer's variant B uses
        this for the agency row. Initials letter on a deterministic OKLCH
        warm-palette colour derived from the agency name.
    -->
    <span :style="rootStyle">{{ initials }}</span>
</template>

<script>
// Warm-palette OKLCH hash matches the prototype's per-agency colour scheme
// (variant B ships pre-baked colours via the `color` field; if absent we
// derive from the name so each agency gets a stable tile colour).
const PALETTE = [
    "oklch(0.55 0.18 280)",
    "oklch(0.62 0.17 25)",
    "oklch(0.66 0.15 145)",
    "oklch(0.63 0.17 230)",
    "oklch(0.45 0.04 250)",
    "oklch(0.55 0.18 30)",
    "oklch(0.65 0.18 260)",
    "oklch(0.50 0.18 30)",
    "oklch(0.60 0.13 200)",
    "oklch(0.55 0.20 350)",
    "oklch(0.55 0.20 290)",
    "oklch(0.45 0.06 245)",
    "oklch(0.62 0.18 25)",
    "oklch(0.60 0.15 155)",
    "oklch(0.55 0.16 200)",
];

function hashColor(name) {
    if (!name) return PALETTE[0];
    let h = 0;
    for (let i = 0; i < name.length; i++) h += name.charCodeAt(i);
    return PALETTE[h % PALETTE.length];
}

export default {
    name: "AgencyMark",
    props: {
        name: { type: String, default: "" },
        // Optional explicit OKLCH colour. Falls back to the name-hash.
        color: { type: String, default: null },
        size: { type: Number, default: 22 },
    },
    computed: {
        initials() {
            const n = (this.name || "").trim();
            if (!n) return "?";
            return n.charAt(0).toUpperCase();
        },
        rootStyle() {
            return {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${this.size}px`,
                height: `${this.size}px`,
                borderRadius: "5px",
                background: this.color || hashColor(this.name),
                color: "#fff",
                fontSize: `${Math.round(this.size * 0.5)}px`,
                fontWeight: 700,
                letterSpacing: "-0.02em",
                flex: `0 0 ${this.size}px`,
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.10)",
            };
        },
    },
};
</script>
